export default class Language {
    constructor(displayName, compilerName) {
        this.displayName = displayName;
        this.compilerName = compilerName;
    }
}
